import React, { useEffect, useState } from "react";
import { SocialShare } from "@quintype/components";
import Headline from "../../atoms/Headline";
import { useSelector } from "react-redux";
import { get, slice } from "lodash";
import { SocialShareTemplate } from "../../../arrow";
import ListingAdSlot from "../../molecules/ListingAdSlot";
import { ALL_RANKINGS_DESCRIPTION } from "../../../../../config/entity-ranking-descriptions";
import { getCategoryAndSubCategory, getTemplateName } from "../../../ga-utils";

import "./all-rankings.m.css";

const EntityCard = ({ entityType, withoutYear = false, index, pageType }) => {
  const { name, linkTo, svgType } = entityType;

  let shareLink = linkTo;
  if (withoutYear) {
    const split = linkTo.split("/");
    if (split.length > 3) {
      shareLink = withoutYear ? linkTo.replace(/\/[^/]*$/, "") : linkTo;
    }
  }

  // Handle click with tracking before navigation
  const handleClick = (e) => {
    e.preventDefault();
    if (typeof window !== "undefined" && window.dataLayer) {
      const { category, subCategory, contentId } = getCategoryAndSubCategory(window.location, pageType);
      // Push to dataLayer
      window.dataLayer.push({
        event: "dl_allranking_list_click",
        link_position: index + 1,
        link_category: name?.toLowerCase(),
        category: category,
        sub_category: subCategory,
        content_id: contentId,
        template_name: getTemplateName(pageType),
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
        eventCallback: () => {
          window.location.href = shareLink;
        },
      });

      setTimeout(() => {
        window.location.href = shareLink;
      }, 100);
    }
  };

  return (
    <a href={shareLink} styleName="entity-card" onClick={handleClick}>
      <div styleName="entity-logo-wrapper">
        <img src={`/images/logos/${svgType}.png`} />
      </div>
      <center>
        <Headline type={2}>{name}</Headline>
      </center>
    </a>
  );
};

export const AllRankingsPage = ({ data }) => {
  const {
    rankingEntities: { options = [] },
  } = data;
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], {}));
  const isAdfreePage = get(qtState, ["config", "subscriber"]) === "true";

  const { all_ranking_title, all_ranking_description } = get(qtState, ["config", "publisher-attributes"], {});
  const [shareLink, setShareLink] = useState("");
  // Track all rankings page interactions
  let isTracking = false;
  const trackAllRankingsInteraction = (action, value) => {
    if (isTracking) return;
    isTracking = true;
    setTimeout(() => {
      isTracking = false;
    }, 300);
    if (typeof window !== "undefined" && window.dataLayer) {
      const { category, subCategory, contentId } = getCategoryAndSubCategory(window.location, pageType);
      window.dataLayer.push({
        event: "dl_allranking_list_click",
        event_action: action,
        link_text: value?.toLowerCase(),
        category: category,
        sub_category: subCategory,
        content_id: contentId,
        template_name: getTemplateName(pageType),
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      });
    }
  };

  useEffect(() => {
    setShareLink(window.location.href);
  }, []);
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "dl_page_info",
      cms_author_name: "NA",
      byline: "NA",
      category: "rankings",
      sub_category: "NA",
      content_id: "NA",
      template_name: "listing",
      publish_date: "NA",
      publish_time: "NA",
      login_status: "not-logged-in", // will be changed
      subscription_status: "not-subscribed", // will be changed
      ad_free: false, // will be changed
      login_wall_enabled: false,
      platform: window.innerWidth >= 768 ? "Desktop" : "Mobile",
    });
  }, []);

  return (
    <div styleName="entity-page-wrapper">
      <div styleName="entity-page-title">
        <Headline type={1}>{all_ranking_title}</Headline>
        <span styleName="all-ranking-share" className="content-style">
          <SocialShare
            template={(props) =>
              SocialShareTemplate({
                ...props,
                onShareClick: (platform) =>
                  trackAllRankingsInteraction("share_click", platform?.toLowerCase() || "share"),
              })
            }
            fullUrl={encodeURI(shareLink)}
            title={"Fortune India Rankings"}
            shareIconId={`share-icon-rankings`}
          />
        </span>
      </div>
      <div styleName="entity-page-description">
        <div styleName="h3-ranking-sub-headline">{ALL_RANKINGS_DESCRIPTION}</div>
      </div>
      <div styleName="entity-card-wrapper">
        {options.map((entityType, index) => (
          <EntityCard
            key={`${entityType?.svgType}`}
            entityType={entityType}
            withoutYear={true}
            index={index}
            pageType={pageType}
          />
        ))}
      </div>
      {!isAdfreePage && (
        <ListingAdSlot adStyleName="ad-slot-size-728x90-300x250" adType="above_footer" pageType="all-rankings" />
      )}
    </div>
  );
};
